import React, { useState } from 'react';

import { default as OneStar} from "@assets/images/reviews/emoticons/review-1-star.svg?react";
import { default as TwoStar} from "@assets/images/reviews/emoticons/review-2-star.svg?react";
import { default as ThreeStar} from "@assets/images/reviews/emoticons/review-3-star.svg?react";
import { default as FourStar} from "@assets/images/reviews/emoticons/review-4-star.svg?react";
import { default as FiveStar} from "@assets/images/reviews/emoticons/review-5-star.svg?react";

import scss from './Rating.module.scss'
import { Badge } from 'react-bootstrap';

interface RatingProps {
  initialRating?: number;
  showWarning?: boolean;
  onRatingChange?: (rating: number) => void;
}

const ICONS = [
  <OneStar className={scss.icon} />,
  <TwoStar className={scss.icon} />,
  <ThreeStar className={scss.icon} />,
  <FourStar className={scss.icon} />,
  <FiveStar className={scss.icon} />,
];

const RATING_DESCRIPTORS = [
  'Terrible',
  'Bad',
  'Average',
  'Good',
  'Amazing'
];

const Rating: React.FC<RatingProps> = ({ initialRating = 0, showWarning, onRatingChange }) => {
  const [rating, setRating] = useState(initialRating);

  const handleStarClick = (clickedRating: number) => {
    setRating(clickedRating);
    if (onRatingChange) {
      onRatingChange(clickedRating);
    }
  };

  return (
    <div className={scss.ratingsContainer}>
      <div className={scss.ratingText}>Star Rating <span className={'text-danger'}>*</span> {rating > 0 ? <Badge bg={'primary'}>{RATING_DESCRIPTORS[rating - 1]}</Badge> : (showWarning && <small className={'text-danger'}>This field is required</small>)}</div>
      <div className={scss.ratingsButtons}>
        {[1, 2, 3, 4, 5].map((star) => (
          <div
            key={star}
            onClick={() => handleStarClick(star)}
            className={star === rating ? scss.selected : scss.unselected}
            data-testid={`rating-${star}`}
          >
            {ICONS[star - 1]}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Rating;